import $ from "jquery";
import eSputnik from "../eSputnik";
import { GAAddToWishList } from "../ga/add_to_wishlist";

export const updateWishlistCounter = (count) => {
  const counter = $(".js_compare_count");
  counter.text(count)[count > 0 ? "removeClass" : "addClass"]("hide");
};

const updateTitle = (el) => {
  const title = el.attr("title");
  const altTitle = el.attr("data-alt-title");
  el.attr({
    title: altTitle,
    "data-alt-title": title,
  });
};

const locale = $("html").attr("lang");
const wishlist = () => {
  $(document).on("click", ".js_favorite", function addToWishlist(e) {
    e.preventDefault();
    const $this = $(this);
    const bool = $this.hasClass("active");
    const id = $this.parents(".product-card__content").data("id") || $(".block-product").attr("data-id");


    if (!bool) {
      $.ajax({
        url: `/api/favorites?product_id=${id}`,
        type: "POST",
        headers: {
          "Accept-Language": locale,
        },
        contentType: "application/json",
        dataType: "json",
        success: ({ data }) => {
          $this.addClass("active");
          updateTitle($this);
          updateWishlistCounter(data.favorites.length);
          GAAddToWishList(data.favorites.item);
          // eSputnik
          const addedProduct = data.favorites.item || {}
          eSputnik.AddToWishlist({
            'productKey': String(addedProduct.sku),            
            'price': String(addedProduct.price?.current),
            'isInStock': 1
          })
        },
      });
    } else {
      $.ajax({
        url: `/api/favorites/${id}/`,
        type: "DELETE",
        dataType: "json",
        success: ({ data }) => {
          $this.removeClass("active");
          updateTitle($this)
          updateWishlistCounter(data.favorites.length);
        },
      });
    }
  });
};

export default wishlist;
